import { Environment } from "../../../../context/PageMetadata";
export const generateBaseUrlsFromHostname = (hostname) => {
    const baseUrl = hostname.split(".").slice(-2).join(".");
    const baseUrls = {
        test: `https://playtest-buddies-stage.${baseUrl}/playtest-buddies/v1`,
        preview: `https://playtest-buddies-stage.${baseUrl}/playtest-buddies/v1`,
        live: `https://playtest-buddies.${baseUrl}/playtest-buddies/v1`,
    };
    return baseUrls;
};
export const generateEndpointsByID = ({ campaignID, environment, hostname, }) => {
    const { test, preview, live } = generateBaseUrlsFromHostname(hostname);
    const REGISTER_ENDPOINT = {
        [Environment.test]: `${test}/campaigns/${campaignID}/optin`,
        [Environment.preview]: `${preview}/campaigns/${campaignID}/optin`,
        [Environment.live]: `${live}/campaigns/${campaignID}/optin`,
    };
    const BETA_KEY_ENDPOINT = {
        [Environment.test]: `${test}/campaigns/${campaignID}/keys`,
        [Environment.preview]: `${preview}/campaigns/${campaignID}/keys`,
        [Environment.live]: `${live}/campaigns/${campaignID}/keys`,
    };
    const USER_STATUS_ENDPOINT = {
        [Environment.test]: `${test}/campaigns/${campaignID}/status`,
        [Environment.preview]: `${preview}/campaigns/${campaignID}/status`,
        [Environment.live]: `${live}/campaigns/${campaignID}/status`,
    };
    return {
        REGISTER_ENDPOINT: getEndpointByEnvironment({ environment, endpointObject: REGISTER_ENDPOINT }),
        BETA_KEY_ENDPOINT: getEndpointByEnvironment({ environment, endpointObject: BETA_KEY_ENDPOINT }),
        USER_STATUS_ENDPOINT: getEndpointByEnvironment({ environment, endpointObject: USER_STATUS_ENDPOINT }),
    };
};
const getEndpointByEnvironment = ({ endpointObject, environment, }) => {
    return Object.hasOwn(endpointObject, environment)
        ? endpointObject[environment]
        : endpointObject[Environment.live];
};
export const getRedeemCodeEndpoint = ({ code, environment, hostname, }) => {
    const { test, preview, live } = generateBaseUrlsFromHostname(hostname);
    const environmentEndpointMap = {
        [Environment.test]: `${test}/invites/${code}/redeem`,
        [Environment.preview]: `${preview}/invites/${code}/redeem`,
        [Environment.live]: `${live}/invites/${code}/redeem`,
    };
    return getEndpointByEnvironment({ endpointObject: environmentEndpointMap, environment });
};
//# sourceMappingURL=endpoints.js.map